// extracted by mini-css-extract-plugin
module.exports = {"wrap":"im-z","heading":"jm-z","items":"km-z","featureCss":"lm-z","disabled":"mm-z","imgCss":"nm-z"};